import React from "react";

export default function DashboardActivitySection({
  GlassCard,
  longPressHandlers,
  handleWidgetClick,
  isEditMode,
  icons,
  currentSlogan,
  handleGoalChange,
  selectedDepartment,
  theme,
  currentGoals,
}) {
  return (
    <GlassCard
      {...longPressHandlers}
      onClick={handleWidgetClick}
      className="p-8 flex flex-col h-full bg-gradient-to-br from-white to-gray-50 overflow-hidden relative"
      noHover
      isEditMode={isEditMode}
    >
      <div className="absolute right-0 top-0 opacity-10 pointer-events-none">
        <img src={icons.target} width={150} alt="bg" />
      </div>
      <div className="relative z-10 w-full h-full flex flex-col justify-center">
        <h3 className="text-sm font-bold text-gray-400 uppercase tracking-widest mb-2">DEPARTMENT VISION</h3>
        {isEditMode ? (
          <textarea
            value={currentSlogan}
            onChange={(e) => handleGoalChange(selectedDepartment, "slogan", e.target.value)}
            className={`text-2xl md:text-3xl font-black ${theme.text} font-do-hyeon mb-6 leading-tight bg-white/50 border border-blue-300 rounded-lg w-full resize-none focus:outline-none focus:ring-2 focus:ring-blue-500 p-2`}
            rows={2}
            onMouseDown={(e) => e.stopPropagation()}
          />
        ) : (
          <h2 className={`text-2xl md:text-3xl font-black ${theme.text} font-do-hyeon mb-6 leading-tight whitespace-pre-wrap`}>
            "{currentSlogan}"
          </h2>
        )}

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-3">
          {currentGoals.map((goal, idx) => (
            <div key={idx} className="bg-white/80 backdrop-blur-md p-3 md:p-4 rounded-2xl border border-gray-100 shadow-sm flex items-center gap-3">
              <div className={`w-6 h-6 md:w-8 md:h-8 rounded-full ${theme.lightBg} ${theme.text} flex items-center justify-center font-bold shrink-0 text-xs md:text-sm`}>{idx + 1}</div>
              {isEditMode ? (
                <input
                  value={goal}
                  onChange={(e) => handleGoalChange(selectedDepartment, "goals", e.target.value, idx)}
                  className="font-bold text-gray-700 bg-white border border-blue-300 rounded px-2 py-1 w-full text-xs md:text-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
                  onMouseDown={(e) => e.stopPropagation()}
                />
              ) : (
                <span className="font-bold text-gray-700 text-xs md:text-sm word-keep-all">{goal}</span>
              )}
            </div>
          ))}
        </div>
      </div>
    </GlassCard>
  );
}
